module.exports = __webpack_public_path__ + "static/img/amplitude.0c8de35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/amplitude.png
// module id = aC+d
// module chunks = 0 139